'use strict';

(function() {
  /**
   * PublicationsController - contrôleur pour la page des publications
   */
  angular
    .module('observatoireApp')
    .controller('PublicationsController', ['$scope', '$sce', 'PublicationsService', 'FavorisService', 'Auth', function($scope, $sce, PublicationsService, FavorisService, Auth) {
      
      // Favoris
      Auth.identity().then(function(user) {
        $scope.utilisateurConnecte = !!user;
      });

      $scope.isFavoriPublication = function(publication) {
        return FavorisService.isFavori('pub_' + publication.id);
      };

      $scope.toggleFavoriPublication = function(publication) {
        if (!$scope.utilisateurConnecte) return;
        var favoriId = 'pub_' + publication.id;
        if (FavorisService.isFavori(favoriId)) {
          FavorisService.removeFavori(favoriId);
        } else {
          FavorisService.addFavori({
            id: favoriId,
            itemType: 'publication',
            titre: publication.title,
            categorie: publication.categoryName || 'Publication',
            fileUrl: publication.fileUrl || null,
            fileType: publication.fileType || null,
            dateAjout: new Date()
          });
        }
      };

      // Initialisation
      $scope.isLoading = true;
      $scope.publications = [];
      $scope.filteredPublications = [];
      $scope.displayedPublications = [];
      $scope.categories = [];
      $scope.selectedCategory = null;
      $scope.searchText = '';
      $scope.currentPage = 1;
      
      // Initialiser l'objet pour les étoiles
      $scope.stars = [1, 2, 3, 4, 5];
      

      
      // Récupérer le nombre d'éléments par page depuis localStorage ou utiliser la valeur par défaut
      var savedItemsPerPage = localStorage.getItem('publicationsItemsPerPage');
      $scope.itemsPerPage = savedItemsPerPage ? parseInt(savedItemsPerPage) : 9;
      
      $scope.totalItems = 0;
      $scope.totalPages = 1;
      $scope.maxPageButtons = 5; // Nombre maximum de boutons de page à afficher
      
      // Erreur de chargement
      $scope.hasError = false;
      $scope.errorMessage = '';
      
      // Publication sélectionnée pour la visualisation
      $scope.selectedPublication = null;
      $scope.trustedPdfUrl = null;
      
      /**
       * Initialisation du contrôleur
       */
      function init() {
        loadPublications();
        loadCategories();
      }
      
      /**
       * Charge les notes précédemment attribuées par l'utilisateur
       */
      function loadUserRatings() {
        var userRatings = PublicationsService.loadUserRatings();
        
        // Si des notes existent, les appliquer aux publications
        if (Object.keys(userRatings).length > 0) {
          $scope.publications.forEach(function(publication) {
            if (userRatings[publication.id]) {
              publication.userRating = userRatings[publication.id];
            }
          });
        }
      }
      
      /**
       * Chargement des publications
       */
      function loadPublications() {
        $scope.isLoading = true;
        
        // Charger les données de notation locales
        var localRatings = {};
        try {
          var ratingsStr = localStorage.getItem('publications_ratings');
          if (ratingsStr) {
            localRatings = JSON.parse(ratingsStr);
            console.log('Données de notation locales chargées:', localRatings);
          }
        } catch(e) {
          console.error('Erreur lors du chargement des données de notation locales:', e);
        }
        
        PublicationsService.getAllPublications()
          .then(function(result) {
            // Appliquer les données de notation locales aux publications
            result.forEach(function(pub) {
              if (localRatings[pub.id]) {
                pub.rating = parseFloat(localRatings[pub.id].rating) || 0;
                pub.ratingCount = parseInt(localRatings[pub.id].ratingCount) || 0;
                console.log('Notation locale appliquée à publication ID:', pub.id, 'Rating:', pub.rating, 'Count:', pub.ratingCount);
              }
            });
            
            // Appliquer les notes utilisateur sauvegardées (localStorage)
            var userRatings = PublicationsService.loadUserRatings();
            result.forEach(function(pub) {
              if (userRatings[pub.id]) {
                pub.userRating = parseInt(userRatings[pub.id]) || 0;
              }
            });

            $scope.publications = result;
            $scope.filteredPublications = $scope.publications.slice();
            $scope.totalItems = $scope.filteredPublications.length;
            applyFilters();
            $scope.isLoading = false;
            $scope.calculateTotalPages();
            $scope.updateDisplayedPublications();
          })
          .catch(function(error) {
            $scope.isLoading = false;
            $scope.hasError = true;
            $scope.errorMessage = 'Erreur lors du chargement des publications: ' + error.message;
            console.error('Erreur lors du chargement des publications', error);
          });
      }
      
      /**
       * Chargement des catégories
       */
      function loadCategories() {
        PublicationsService.getCategories()
          .then(function(result) {
            $scope.categories = result;
            console.log('Catégories chargées:', result);
          })
          .catch(function(error) {
            console.error('Erreur lors du chargement des catégories', error);
          });
      }
      
      /**
       * Filtrer les publications
       */
      function applyFilters() {
        console.log('Application des filtres, catégorie sélectionnée:', $scope.selectedCategory);
        console.log('Publications avant filtrage:', $scope.publications.length);
        
        $scope.filteredPublications = $scope.publications.filter(function(pub) {
          // Filtre par catégorie - uniquement par ID
          var categoryMatch = false;
          
          if ($scope.selectedCategory === null) {
            // Si aucune catégorie n'est sélectionnée, match toutes les publications
            categoryMatch = true;
          } else {
            // Filtrer strictement par l'ID de la catégorie
            if (pub.category && typeof pub.category === 'object' && pub.category.id) {
              // Si la catégorie est un objet avec un ID, comparer cet ID
              categoryMatch = pub.category.id === $scope.selectedCategory;
              if (categoryMatch) {
                console.log('Match par ID (objet):', pub.title, '- ID catégorie:', pub.category.id);
              }
            } else if (typeof pub.category === 'string') {
              // Si la catégorie est une chaîne, comparer directement
              categoryMatch = pub.category === $scope.selectedCategory;
              if (categoryMatch) {
                console.log('Match par ID (chaîne):', pub.title, '- ID catégorie:', pub.category);
              }
            }
          }
          
          // Filtre par texte
          var q = ($scope.searchText || '').toLowerCase();
          var textMatch = q === '' ||
                         (pub.title && pub.title.toLowerCase().indexOf(q) !== -1) ||
                         (pub.description && pub.description.toLowerCase().indexOf(q) !== -1) ||
                         (pub.author && pub.author.toLowerCase().indexOf(q) !== -1) ||
                         (pub.categoryName && pub.categoryName.toLowerCase().indexOf(q) !== -1) ||
                         (pub.tags && pub.tags.some(function(t) { return t.toLowerCase().indexOf(q) !== -1; }));
          
          return categoryMatch && textMatch;
        });
        
        console.log('Publications après filtrage:', $scope.filteredPublications.length);
        $scope.totalItems = $scope.filteredPublications.length;
        $scope.currentPage = 1;
        $scope.calculateTotalPages();
        $scope.updateDisplayedPublications();
      }
      
      /**
       * Filtrer par catégorie
       * @param {string} categoryId L'identifiant de la catégorie à filtrer
       */
      $scope.filterByCategory = function(categoryId) {
        $scope.selectedCategory = categoryId; // Stocke l'ID de la catégorie
        console.log('Filtrage par catégorie:', categoryId);
        
        // Afficher les publications et leur catégorie pour débogage
        console.log('Catégories disponibles:', $scope.categories);
        console.log('Publications et leurs catégories:', $scope.publications.map(function(pub) {
          return {
            id: pub.id,
            title: pub.title, 
            categoryInfo: {
              categoryObj: pub.category,
              categoryType: typeof pub.category,
              categoryName: pub.categoryName
            }
          };
        }));
        
        applyFilters();
      };
      
      /**
       * Rechercher dans les publications
       */
      $scope.search = function() {
        applyFilters();
      };
      
      /**
       * Réinitialiser les filtres
       */
      $scope.resetFilters = function() {
        $scope.selectedCategory = null;
        $scope.searchText = '';
        applyFilters();
      };
      
      /**
       * Nombre de publications par catégorie
       */
      $scope.getCategoryCount = function(categoryId) {
        return $scope.publications.filter(function(pub) {
          var pubCatId = (pub.category && typeof pub.category === 'object') ? pub.category.id : pub.category;
          return pubCatId === categoryId;
        }).length;
      };

      /**
       * Changer de page
       */
      $scope.pageChanged = function() {
        // Mise à jour des publications affichées
        console.log('Page changed to: ' + $scope.currentPage);
        $scope.updateDisplayedPublications();
      };
      
      /**
       * Visualiser une publication dans le modal
       */
      $scope.visualizePublication = function(publication) {
        if (publication && publication.fileUrl) {
          // Définir la publication sélectionnée
          $scope.selectedPublication = publication;
          // Capturer la date formatée une seule fois — immunisée contre toute mise à jour API
          $scope.viewerDate = $scope.formatDate(publication.date);
          
          // Pour les PDF, nous devons whitelister l'URL avec $sce
          if (publication.fileType === 'PDF') {
            $scope.trustedPdfUrl = $sce.trustAsResourceUrl(publication.fileUrl);
          }
          
          // Incrémenter le nombre de vues
          PublicationsService.incrementViews(publication.id)
            .then(function(updatedPublication) {
              // Mettre à jour la publication dans la liste
              updatePublicationInLists(updatedPublication);
            })
            .catch(function(error) {
              console.error('Erreur lors de l\'incrémentation des vues', error);
            });
          
          // Ouvrir le modal
          $('#publicationViewerModal').modal('show');
        }
      };
      
      /**
       * Fermer le visualiseur
       */
      $scope.closeViewer = function() {
        $('#publicationViewerModal').modal('hide');
        // Nettoyer les variables
        $scope.selectedPublication = null;
        $scope.trustedPdfUrl = null;
      };
      
      /**
       * Télécharger une publication
       */
      $scope.downloadPublication = function(publication) {
        if (publication.fileUrl) {
          // Incrémenter le nombre de téléchargements
          PublicationsService.incrementDownloads(publication.id)
            .then(function(updatedPublication) {
              // Mettre à jour la publication dans la liste
              updatePublicationInLists(updatedPublication);
            })
            .catch(function(error) {
              console.error('Erreur lors de l\'incrémentation des téléchargements', error);
            });

          // Créer un lien temporaire pour forcer le téléchargement
          var a = document.createElement('a');
          a.href = publication.fileUrl;
          a.download = publication.title.replace(/[^a-z0-9]/gi, '_').toLowerCase() + '.' + publication.fileType.toLowerCase();
          document.body.appendChild(a);
          a.click();
          document.body.removeChild(a);
        }
      };
      
      /**
       * Partager une publication
       */
      $scope.sharePublication = function(publication) {
        // S'assurer que l'URL du PDF existe
        if (!publication.fileUrl) {
          alert('Impossible de partager : aucun fichier PDF associé à cette publication.');
          return;
        }
        
        // Implémentation du partage 
        if (navigator.share) {
          navigator.share({
            title: publication.title,
            text: publication.description,
            url: publication.fileUrl // Partager directement l'URL du PDF
          })
          .then(() => {
            console.log('Publication PDF partagée');
            // Incrémenter éventuellement un compteur de partages si nécessaire
          })
          .catch((error) => console.log('Erreur lors du partage', error));
        } else {
          // Fallback pour les navigateurs qui ne supportent pas l'API Web Share
          // Créer un élément textarea temporaire pour copier l'URL du PDF
          var tempTextarea = document.createElement('textarea');
          tempTextarea.value = publication.fileUrl;
          document.body.appendChild(tempTextarea);
          tempTextarea.select();
          
          try {
            var successful = document.execCommand('copy');
            if (successful) {
              alert('L\'URL du PDF a été copiée dans votre presse-papiers. Vous pouvez maintenant la partager.');
            } else {
              alert('Impossible de copier l\'URL. Veuillez la copier manuellement : ' + publication.fileUrl);
            }
          } catch (err) {
            alert('Impossible de partager automatiquement. URL du PDF : ' + publication.fileUrl);
          }
          
          document.body.removeChild(tempTextarea);
        }
      };
      
      /**
       * Calcule le nombre total de pages
       */
      $scope.calculateTotalPages = function() {
        $scope.totalPages = Math.ceil($scope.totalItems / $scope.itemsPerPage);
        if ($scope.totalPages === 0) {
          $scope.totalPages = 1;
        }
        // Assurez-vous que la page courante n'est pas supérieure au nombre total de pages
        if ($scope.currentPage > $scope.totalPages) {
          $scope.currentPage = $scope.totalPages;
        }
      };
      
      /**
       * Navigue vers une page spécifique
       * @param {number} page - Le numéro de page
       */
      $scope.goToPage = function(page) {
        if (page < 1 || page > $scope.totalPages || page === $scope.currentPage) {
          return;
        }
        
        $scope.currentPage = page;
        $scope.pageChanged();
      };
      
      /**
       * Génère la plage de pages à afficher
       * @returns {Array} La plage de pages
       */
      $scope.getPageRange = function() {
        var pages = [];
        var startPage, endPage;
        
        if ($scope.totalPages <= $scope.maxPageButtons) {
          // Afficher toutes les pages si leur nombre est inférieur au maximum
          startPage = 1;
          endPage = $scope.totalPages;
        } else {
          // Calculer les pages de début et de fin
          var maxPagesBeforeCurrentPage = Math.floor($scope.maxPageButtons / 2);
          var maxPagesAfterCurrentPage = Math.ceil($scope.maxPageButtons / 2) - 1;
          
          if ($scope.currentPage <= maxPagesBeforeCurrentPage) {
            // Page courante proche du début
            startPage = 1;
            endPage = $scope.maxPageButtons;
          } else if ($scope.currentPage + maxPagesAfterCurrentPage >= $scope.totalPages) {
            // Page courante proche de la fin
            startPage = $scope.totalPages - $scope.maxPageButtons + 1;
            endPage = $scope.totalPages;
          } else {
            // Page courante au milieu
            startPage = $scope.currentPage - maxPagesBeforeCurrentPage;
            endPage = $scope.currentPage + maxPagesAfterCurrentPage;
          }
        }
        
        // Ajouter les pages à la plage
        for (var i = startPage; i <= endPage; i++) {
          pages.push(i);
        }
        
        return pages;
      };
      
      /**
       * Définit le nombre d'éléments à afficher par page
       * @param {number} numItems - Le nombre d'éléments à afficher par page
       */
      $scope.setItemsPerPage = function(numItems) {
        // Mettre à jour le nombre d'éléments par page
        $scope.itemsPerPage = numItems;
        console.log('Changement du nombre d\'éléments par page : ' + $scope.itemsPerPage);
        
        // Sauvegarder la préférence dans localStorage
        localStorage.setItem('publicationsItemsPerPage', $scope.itemsPerPage);
        
        // Recalculer le nombre total de pages
        $scope.calculateTotalPages();
        
        // Revenir à la première page
        $scope.currentPage = 1;
        
        // Mettre à jour les publications affichées
        $scope.updateDisplayedPublications();
        
        // Pour déboguer - afficher l'état actuel
        console.log('Nombre total d\'éléments : ' + $scope.totalItems);
        console.log('Nombre total de pages : ' + $scope.totalPages);
        console.log('Page actuelle : ' + $scope.currentPage);
        console.log('Nombre d\'éléments affichés : ' + $scope.displayedPublications.length);
      };
      
      /**
       * Change le nombre d'éléments affichés par page (pour compatibilité)
       */
      $scope.changeItemsPerPage = function() {
        // Convertir la valeur en nombre
        var newItemsPerPage = parseInt($scope.itemsPerPage);
        if (isNaN(newItemsPerPage) || newItemsPerPage <= 0) {
          newItemsPerPage = 9; // Valeur par défaut
        }
        $scope.setItemsPerPage(newItemsPerPage);
      };
      
      /**
       * Met à jour la liste des publications affichées en fonction de la page courante
       */
      $scope.updateDisplayedPublications = function() {
        // Forcer la conversion du nombre d'éléments par page en nombre entier
        $scope.itemsPerPage = Number($scope.itemsPerPage);
        
        // Calculer les indices de début et de fin pour la pagination
        var startIndex = ($scope.currentPage - 1) * $scope.itemsPerPage;
        var endIndex = startIndex + $scope.itemsPerPage;
        
        // S'assurer que les indices sont valides
        if (startIndex < 0) startIndex = 0;
        if (endIndex > $scope.filteredPublications.length) {
          endIndex = $scope.filteredPublications.length;
        }
        
        // Vider le tableau existant et le remplir avec les éléments de la page actuelle
        $scope.displayedPublications = [];
        for (var i = startIndex; i < endIndex; i++) {
          $scope.displayedPublications.push($scope.filteredPublications[i]);
        }
        
        console.log('Nombre d\'\u00e9léments par page: ' + $scope.itemsPerPage);
        console.log('Affichage des éléments ' + startIndex + ' à ' + endIndex + ' sur ' + $scope.totalItems);
        console.log('Nombre d\'\u00e9léments affichés: ' + $scope.displayedPublications.length);
      };
      
      // Mise à jour du nombre total de pages lorsque les filtres sont appliqués
      $scope.$watch('filteredPublications.length', function(newVal) {
        $scope.totalItems = newVal;
        $scope.calculateTotalPages();
        $scope.updateDisplayedPublications();
      });
      
      /**
       * Mettre à jour une publication dans les listes après modification
       * @param {Object} updatedPublication - La publication mise à jour
       */
      function updatePublicationInLists(updatedPublication) {
        var patch = {
          views:       parseInt(updatedPublication.views)       || 0,
          downloads:   parseInt(updatedPublication.downloads)   || 0,
          rating:      parseFloat(updatedPublication.rating)    || 0,
          ratingCount: parseInt(updatedPublication.ratingCount) || 0,
          userRating:  parseInt(updatedPublication.userRating)  || 0
        };

        function applyPatch(list) {
          for (var i = 0; i < list.length; i++) {
            if (list[i].id === updatedPublication.id) {
              list[i].views       = patch.views;
              list[i].downloads   = patch.downloads;
              list[i].rating      = patch.rating;
              list[i].ratingCount = patch.ratingCount;
              list[i].userRating  = patch.userRating;
              break;
            }
          }
        }

        applyPatch($scope.publications);
        applyPatch($scope.filteredPublications);
        applyPatch($scope.displayedPublications);

        if ($scope.selectedPublication && $scope.selectedPublication.id === updatedPublication.id) {
          $scope.selectedPublication.views       = patch.views;
          $scope.selectedPublication.downloads   = patch.downloads;
          $scope.selectedPublication.rating      = patch.rating;
          $scope.selectedPublication.ratingCount = patch.ratingCount;
          $scope.selectedPublication.userRating  = patch.userRating;
        }
        
        // Forcer Angular à mettre à jour l'interface utilisateur
        if (!$scope.$$phase) {
          $scope.$apply();
        }
      }
      
      /**
       * Attribue une note à une publication
       * @param {Object} publication - La publication à noter
       * @param {number} rating - La note (1-5)
       */
      $scope.ratePublication = function(publication, rating) {
        if (!publication || !rating) return;

        var previous = publication.userRating || 0;
        var count     = publication.ratingCount || 0;
        var avg       = parseFloat(publication.rating) || 0;

        if (previous === rating) {
          // Même étoile : retirer le vote
          publication.userRating = 0;
          if (count > 1) {
            publication.rating      = Math.round(((avg * count - previous) / (count - 1)) * 10) / 10;
            publication.ratingCount = count - 1;
          } else {
            publication.rating      = 0;
            publication.ratingCount = 0;
          }
        } else if (previous > 0) {
          // Modifier un vote existant
          publication.userRating  = rating;
          publication.rating      = Math.round(((avg * count - previous + rating) / count) * 10) / 10;
        } else {
          // Nouveau vote
          publication.userRating  = rating;
          publication.rating      = Math.round(((avg * count + rating) / (count + 1)) * 10) / 10;
          publication.ratingCount = count + 1;
        }

        // Persister dans localStorage
        try {
          var saved = JSON.parse(localStorage.getItem('publications_user_ratings') || '{}');
          saved[publication.id] = publication.userRating;
          localStorage.setItem('publications_user_ratings', JSON.stringify(saved));
        } catch(e) {}

        if (publication.userRating === 0) return;

        // Synchroniser avec l'API en arrière-plan
        PublicationsService.ratePublication(publication.id, publication.userRating)
          .then(function(updatedPublication) {
            // Mettre à jour uniquement les champs de notation depuis le serveur
            publication.rating      = parseFloat(updatedPublication.rating)      || publication.rating;
            publication.ratingCount = parseInt(updatedPublication.ratingCount)   || publication.ratingCount;
          })
          .catch(function(error) {
            console.error('Erreur lors de la notation de la publication', error);
          });
      };
      
      /**
       * Vérifie si une étoile doit être remplie ou non
       * @param {Object} publication - La publication à vérifier
       * @param {number} starValue - La valeur de l'étoile (1-5)
       * @returns {boolean} Vrai si l'étoile doit être remplie, faux sinon
       */
      $scope.isStarFilled = function(publication, starValue) {
        // Vérifier si publication existe
        if (!publication) return false;
        // Vérifier si userRating existe
        var userRating = publication.userRating || 0;
        return userRating >= starValue;
      };
      
      /**
       * Vérifie si une étoile doit être remplie ou non en mode prévisualisation
       * @param {Object} publication - La publication à vérifier
       * @param {number} starValue - La valeur de l'étoile (1-5)
       * @param {number} hoverValue - La valeur de l'étoile survolée
       * @returns {boolean} Vrai si l'étoile doit être remplie, faux sinon
       */
      $scope.isStarFilledPreview = function(publication, starValue, hoverValue) {
        // Vérifier si publication existe
        if (!publication) return false;
        
        if (!hoverValue) {
          // Vérifier si userRating existe
          var userRating = publication.userRating || 0;
          return userRating >= starValue;
        }
        return hoverValue >= starValue;
      };
      
      /**
       * Convertit la note moyenne en pourcentage pour l'affichage des étoiles
       * @param {number} rating - La note moyenne (0-5)
       * @returns {string} La largeur des étoiles remplies en pourcentage
       */
      $scope.getRatingPercentage = function(rating) {
        // S'assurer que rating est un nombre valide
        rating = parseFloat(rating) || 0;
        return (Math.min(Math.max(rating, 0), 5) / 5 * 100) + '%';
      };
      
      /**
       * Formate une date au format LocalDateTime Java [année, mois, jour, heure, minute]
       * @param {Array|string|Date} dateValue - La date à formater
       * @returns {Date} - La date formatée
       */
      $scope.formatDate = function(dateValue) {
        if (Array.isArray(dateValue) && dateValue.length >= 3) {
          // Soustraire 1 du mois car en JavaScript les mois sont 0-indexés (0-11)
          return new Date(dateValue[0], dateValue[1] - 1, dateValue[2]);
        }
        return dateValue;
      };

      // Initialiser le contrôleur
      init();
      
    }]);
})();
